/* Copy-a-code buttons (partner-offer bar, kenetik-sampler): [data-copy-code] copies the code and says so in the
   [data-copy-status] live region of its [data-copy-scope] (or .partner-offer). Falls back to selecting the code text
   when the Clipboard API isn't available (older browsers, non-HTTPS preview). Safe to load more than once. */
(() => {
  if (window.kxCopyCode) return;
  window.kxCopyCode = true;
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-copy-code]');
    if (!btn) return;
    const code = btn.dataset.copyCode;
    const bar = btn.closest('[data-copy-scope], .partner-offer');
    const status = bar && bar.querySelector('[data-copy-status]');
    let ok = false;
    try {
      if (navigator.clipboard && window.isSecureContext) { await navigator.clipboard.writeText(code); ok = true; }
    } catch (err) { ok = false; }
    if (!ok) {
      const text = btn.querySelector('[data-copy-text], .partner-offer__code-text');
      const range = document.createRange();
      range.selectNodeContents(text);
      const sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(range);
    }
    const action = btn.querySelector('[data-copy-action], .partner-offer__code-action');
    const label = btn.dataset.copiedLabel || 'Code copied';
    if (ok && action) { action.dataset.label = action.dataset.label || action.textContent; action.textContent = label; btn.classList.add('is-copied'); }
    if (status) status.textContent = ok ? `${label}: ${code}` : code;
    if (ok) setTimeout(() => { if (action) action.textContent = action.dataset.label; btn.classList.remove('is-copied'); }, 2500);
  });
})();
